module.exports = __webpack_public_path__ + "img/sale50procent.1989399e.png";